import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    ASSIGN_USER_REQUEST,
    ASSIGN_USER_SUCCESS,
    ASSIGN_USER_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const AssignUserAction = (id, data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_FB_BOT}/api/users/${id}/conversations`,
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            ASSIGN_USER_REQUEST,
            {
                type: ASSIGN_USER_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": ASSIGN_USER_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: ASSIGN_USER_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": ASSIGN_USER_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {AssignUserAction}